export default {
  asset_mode: {
    isolation: "isolation",
    normal: "normal"
  },
  event_type: {
    temperature: "temperature",
    location: "location"
  },
  campaign_status: {
    Pending: "Pending",
    Active: "Active",
    Paused: "Paused",
    Complete: "Complete"
  },
  campaign_item_status: {
    Pending: "Pending",
    Active: "Active",
    Exempt: "Exempt",
    Complete: "Complete"
  },
  campaign_item_response_status: {
    Pending: "Pending",
    Located: "Located",
    Exception: "Exception",
    Complete: "Complete"
  }
};
